module.exports = __webpack_public_path__ + "img/EASTASIA_VEGETABLE_OILS.fbbf9377.png";